import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "body-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            subheader: "",
            style: 'height: 50vh; overflow: auto',
            lines: "two"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_subheader, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Voici les sociétés à regrouper ")
                ])),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toMergeCompanies, (company) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: company.id,
                  class: "oss-list-item mb-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { style: {"text-overflow":"ellipsis","max-width":"600px"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(company.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(company.siret), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(company.groupKey), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_1, _toDisplayString(company.address) + " " + _toDisplayString(company.city), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_ctx.toMergeCompaniesLoading)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 0,
                    class: "oss-list-item my-1",
                    style: {"background":"#fff"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_skeleton_loader, {
                        ref: "skeleton",
                        type: "list-item-three-line"
                      }, null, 512)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}